"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeRoot = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var SimpleTreeView_1 = require("@mui/x-tree-view/SimpleTreeView");
var TreeRoot = /** @class */ (function (_super) {
    __extends(TreeRoot, _super);
    function TreeRoot(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            treeOpenItems: []
        };
        _this.onExpandedItemsChange = _this.onExpandedItemsChange.bind(_this);
        return _this;
    }
    TreeRoot.prototype.componentDidMount = function () {
        var _this = this;
        this.treeDefaultOpenSubscription = this.treeManager.subscribeToOpen(function (value) { return _this.setState({ treeOpenItems: value }); });
    };
    TreeRoot.prototype.componentWillUnmount = function () {
        var _a;
        (_a = this.treeDefaultOpenSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    TreeRoot.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(SimpleTreeView_1.SimpleTreeView, { expandedItems: this.state.treeOpenItems, onExpandedItemsChange: this.onExpandedItemsChange, children: this.props.children }));
    };
    TreeRoot.prototype.onExpandedItemsChange = function (event, itemIds) {
        this.treeManager.changeOpen(itemIds);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.TreeManager),
        __metadata("design:type", Object)
    ], TreeRoot.prototype, "treeManager", void 0);
    return TreeRoot;
}(React.Component));
exports.TreeRoot = TreeRoot;
//# sourceMappingURL=TreeRoot.js.map